import React, { useState, useEffect } from 'react';
import axios from '../api/axios';
import { toast } from './Toast';
import './FollowupFormModal.css';

function FollowupFormModal({ enquiryId, defaultAssignedToId, onClose, onSuccess }) {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const defaultFollowupDate = tomorrow.toISOString().split('T')[0];

  const [formData, setFormData] = useState({
    notes: '',
    nextFollowupDate: defaultFollowupDate,
    nextFollowupTime: '10:00',
    assignedToId: defaultAssignedToId || ''
  });
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await axios.get('/users?size=1000');
        const list = res.data?.data?.content || res.data?.content || res.data || [];
        setUsers(Array.isArray(list) ? list : []);
      } catch (err) {
        // non-critical if users list fails
      }
    };
    fetchUsers();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const submitData = {
        notes: formData.notes,
        nextFollowupDate: formData.nextFollowupDate || null,
        nextFollowupTime: formData.nextFollowupTime
          ? (formData.nextFollowupTime.length === 5 ? `${formData.nextFollowupTime}:00` : formData.nextFollowupTime)
          : null,
        assignedToId: formData.assignedToId ? Number(formData.assignedToId) : null
      };

      await axios.post(`/enquiries/${enquiryId}/followups`, submitData);
      onSuccess();
    } catch (err) {
      toast.error(err.response?.data?.message || err.response?.data?.error || 'Failed to add follow-up');
      setLoading(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Add Follow-up</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="notes">Follow-up Notes *</label>
            <textarea
              id="notes"
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              required
              disabled={loading}
              className="form-textarea"
              rows="5"
              placeholder="Enter details about the follow-up conversation, customer feedback, next steps, etc."
            />
          </div>

          <div className="followup-datetime-row">
            <div className="form-group">
              <label htmlFor="nextFollowupDate">Next Follow-up Date</label>
              <input
                type="date"
                id="nextFollowupDate"
                name="nextFollowupDate"
                value={formData.nextFollowupDate}
                onChange={handleChange}
                disabled={loading}
                className="form-input"
                min={new Date().toISOString().split('T')[0]}
              />
              <small className="form-hint">Date to follow up</small>
            </div>

            <div className="form-group">
              <label htmlFor="nextFollowupTime">Follow-up Time</label>
              <input
                type="time"
                id="nextFollowupTime"
                name="nextFollowupTime"
                value={formData.nextFollowupTime}
                onChange={handleChange}
                disabled={loading}
                className="form-input"
              />
              <small className="form-hint">Time for reminder alert</small>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="assignedToId">Assign Follow-up To (Employee)</label>
            <select
              id="assignedToId"
              name="assignedToId"
              value={formData.assignedToId}
              onChange={handleChange}
              disabled={loading}
              className="form-input"
            >
              <option value="">-- Inherit from Enquiry Assignee / Self --</option>
              {users.map(u => (
                <option key={u.id} value={u.id}>
                  {u.name} ({u.email}) {u.role ? `• ${u.role}` : ''}
                </option>
              ))}
            </select>
            <small className="form-hint">The assigned employee will receive in-app notification when due</small>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? 'Adding...' : 'Add Follow-up'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default FollowupFormModal;
